import request from '@/util/request'

export function contentIds(panum) {
  return request({
    url: `projectResponse/contentIds/${panum}`,
    method: 'get'
  })
}

export function checkTempCount(panum, templateId) {
  return request({
    url: `projectResponse/checkTempCount/${panum}/${templateId}`,
    method: 'get'
  })
}

export function resetTemplate(panum) {
  return request({
    url: `projectResponse/resetTemplate/${panum}`,
    method: 'get'
  })
}

export function saveTemplateContent(panum, templateId, ids) {
  return request({
    url: `projectResponse/saveTemplateContent/${panum}/${templateId}`,
    method: 'post',
    data: ids
  })
}

export function assignTemplate(panum, userId, templateIds) {
  return request({
    url: `projectResponse/assignTemplate/${userId}/${panum}`,
    method: 'post',
    data: templateIds
  })
}

export function cancelAssign(panum, templateContentId, responsorId) {
  return request({
    url: `projectResponse/cancelAssign/${panum}/${templateContentId}/${responsorId}`,
    method: 'get'
  })
}

export function assignOver(panum) {
  return request({
    url: `projectResponse/assignOver/${panum}`,
    method: 'get'
  })
}

export function uploadMsg() {
  return request({
    url: `projectResponse/uploadMsg`,
    method: 'get'
  })
}

export function auditMsg() {
  return request({
    url: `projectResponse/auditMsg`,
    method: 'get'
  })
}

export function fixFileMsg() {
  return request({
    url: `projectResponse/fixFileMsg`,
    method: 'get'
  })
}

export function dividedList(query) {
  return request({
    url: `projectResponse/divideList`,
    method: 'post',
    data: query
  })
}

export function deleteDivideHistory(panum, templateContentId, responsible, responseTime) {
  return request({
    url: `projectResponse/deleteDivideHistory/${panum}/${templateContentId}/${responsible}/${responseTime}`,
    method: 'get'
  })
}

export function assignAgain(panum, templateContentId, responsible) {
  return request({
    url: `projectResponse/assignAgain/${panum}/${templateContentId}/${responsible}`,
    method: 'get'
  })
}